import { useState } from "react";

const useMessageState = () => {
  const [messages, setMessages] = useState([]);
  const [isViewingHistory, setIsViewingHistory] = useState(false);
  const [selectedDiffLines, setSelectedDiffLines] = useState({});
  const [diffComments, setDiffComments] = useState({});
  const [adoptedExpertOpinions, setAdoptedExpertOpinions] = useState({});
  const [microSceneBubbles, setMicroSceneBubbles] = useState([]);

  return {
    messages,
    setMessages,
    isViewingHistory,
    setIsViewingHistory,
    selectedDiffLines,
    setSelectedDiffLines,
    diffComments,
    setDiffComments,
    adoptedExpertOpinions,
    setAdoptedExpertOpinions,
    microSceneBubbles,
    setMicroSceneBubbles,
  };
};

export default useMessageState;
